import { DefaultTooltip } from "Components/Generic/Tooltip";
import React, { useEffect, useRef, useState } from "react";
import { VisibleOptionsContainer, VisibleOptionsText } from "./styles";

interface VisibleComponentProps {
  optionsNames: string;
}

export const VisibleMoreOptionsComponent = ({ optionsNames }: VisibleComponentProps) => {
  const [hoverStatus, setHover] = useState(false);
  const textElementRef = useRef<HTMLSpanElement>(null);

  const haveEllipsis = (element: HTMLElement) => {
    return !(
      element.offsetWidth === element.scrollWidth && element.offsetHeight === element.scrollHeight
    );
  };

  const compareSize = () => {
    const element = textElementRef?.current;

    if (
      element &&
      element.offsetWidth &&
      element.scrollWidth &&
      element.offsetHeight &&
      element.scrollHeight
    ) {
      setHover(haveEllipsis(element));
    }
  };

  useEffect(() => {
    compareSize();
    window.addEventListener("resize", compareSize);
  }, []);

  useEffect(
    () => () => {
      window.removeEventListener("resize", compareSize);
    },
    []
  );

  return (
    <VisibleOptionsContainer>
      <DefaultTooltip title={optionsNames} disableHoverListener={!hoverStatus}>
        <VisibleOptionsText ref={textElementRef}>{optionsNames}</VisibleOptionsText>
      </DefaultTooltip>
    </VisibleOptionsContainer>
  );
};
